module.exports = __webpack_public_path__ + "img/HeySong_Car_step03_1.2feadd2d.png";